var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"BannerSection"}},[_c('div',{staticClass:"columns is-vcentered"},[_c('div',{staticClass:"column is-5 bg-main-color pl-6"},[_c('h1',{staticClass:"is-size-3 p-4"},[_c('strong',[_vm._v("Garantizamos el total anonimato del denunciante, tanto si es empleado, proveedor o cliente")])])])])])
}]

export { render, staticRenderFns }